import { useEffect, useState } from "react";
import { motion, AnimatePresence, useAnimation } from 'framer-motion';

const images = [
    "/images/digitalocean-2.svg",
    "/images/resellerclub-logo-2x.png",
    "/images/StudioFX-Updated.png",
    "/images/bt_logo.png",
    // "/customers/angelo.webp",
    // "/customers/catdump.png"
];

// Animation variants 
const getPartnersipCardVariant = (i) => {
    // return {}
    return { hidden: { opacity: 0, y: 40 + (i * 40) }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } };
}

export const PartnersipSection = () => {

    // const [currentIndex, setCurrentIndex] = useState(0);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    //     }, 4000);
    //     return () => clearInterval(interval);
    // }, []);

    const controls = useAnimation();

    useEffect(() => {
        const loopAnimation = async () => {
            while (true) {
                await controls.start({
                    x: "-100%",
                    transition: { duration: images.length * 2, ease: "linear" },
                });
                controls.set({ x: "0%" });
            }
        };

        loopAnimation();
    }, [controls, images.length]);

    return (
        <section className="partner-section">
            <div className="inner">

                <div className="col">
                    <h1 className="impact-hdr">Our partners</h1>
                </div>

                <div className="col">
                    <div className="client-logo-scroll">
                        <motion.div animate={controls} className="scroll-container">
                            {images.concat(images).map((img, index) => (
                                <div key={index} className="client-logo-image">
                                    <img src={img} alt={`Client Logo ${index % images.length}`} />
                                </div>
                            ))}
                        </motion.div>
                    </div>
                </div>

            </div>
        </section>
    );
}